export default __webpack_public_path__ + "static/media/le.888ab621.png";